var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-gravatar',{attrs:{"avatar_props":{ size: 100, rounded: true },"email":"example@mail.com","preload":"test"}})}
var staticRenderFns = []

export { render, staticRenderFns }